<form (submit)="onSubmit()" class="step-form" #stepForm>

  <div class="grid-x grid-margin-x check-wrapper">
    @if (hasHelp) {
      <div class="cell small-12 medium-4 medium-order-2 help-wrapper">
        <button type="button" [attr.aria-expanded]="showPageHelp" [attr.aria-controls]="" [attr.aria-label]="'arialabel.toggle.info' | translate" class="help-toggle hide-for-medium" (click)="togglePageHelp()">{{(showPageHelp? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}} <i [class]="showPageHelp? 'icon-x-circle' : 'icon-info'"></i></button>
        @if (helpTextkey) {
          <div class="callout lighter-gray step-help" [class.show]="showPageHelp">
            <div [innerHTML]="helpTextkey | translate"></div>
            @if (hasInlineHelp) {
              <button type="button" [attr.aria-expanded]="showInlineHelp" [attr.aria-controls]="" [attr.aria-label]="'arialabel.toggle.info' | translate" (click)="toggleInlineHelp()" class="show-for-medium"><i class="icon-help-circle"></i> {{'step.help.more' | translate}}</button>
            }
          </div>
        }
      </div>
    }
    <div class="cell small-12 medium-order-1" [class.medium-10]="!hasHelp" [class.medium-6]="hasHelp" [class.nohelp]="!hasHelp" #formWrapper>
      @if (formError) {
        <div role="alert" class="form-errors">
          <p [innerHTML]="textkeyPrefix + '.step.error.' + formError | translate: {fallback: 'step.error.' + formError}"></p>
        </div>
      }
      @for (field of formConfig.getFieldsFromGroup(steps.currentStep.name); track field; let fieldIndex = $index) {
        @if (field.isActive()) {
          <div formfield [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="showInlineHelp" [form]="form" [formModel]="field" [formConfig]="formConfig" [step]="textkeyPrefix" class="formfield {{field.type}} {{field.classes}}"></div>
        }
      }
    </div>
  </div>

  <div class="grid-x grid-margin-x">
    <div class="cell medium-offset-1 medium-10">
      <app-step-buttons
        [backgroundClass]="steps.currentStep.name === 'nutzungstyp' && form.get('nutzungstyp').valid"
        [nextText]="steps.currentStep.name === 'heizungstyp'? 'heizcheck.step.button.next.heizungstyp' : 'step.button.next'"
        [teaserText]="steps.currentStep.name === 'nutzungstyp' && form.get('nutzungstyp').valid ? 'heizcheck.einstieg.buttonteaser' : null" [previousLink]="previousStep? previousStep.path : null"
        [nextSubmit]="!nextUrl" [nextUrl]="nextUrl?? null"
        [nextLink]="nextUrl? null : steps?.nextStep?.path?? '../verbrauchsanalyse/basisinformationen/1'" [nextDisabled]="!form.valid"
        (onNextClick)="submitClicked()"
        mediumOffset="0"
        largeOffset="0"
        mediumWidthRight="auto"
        largeWidthRight="auto">
      </app-step-buttons>
    </div>
  </div>
</form>
